import BaseApi from "../../../services/Api";
import {toast} from "react-toastify";
import Swal from "sweetalert2";
import React, {useEffect, useState} from "react";
import Tooltip from "../../Popups/Tooltip";
import {Modal, Spinner} from "react-bootstrap";
import Button from "../../Layout/Button";
import style from "./style.module.css";

import { useSearchParams } from "react-router-dom";

const INITIAL_DATA = {
  total: 0,
  current_page: 1,
  last_page: 1,
  first_page_url: "",
  last_page_url: "",
  next_page_url: "",
  prev_page_url: null,
  path: "",
  from: 1,
  to: 1,
  data: [],
};

const ModalSuitor = ({
  idSuitor, onUpdate, onCreate, children
}) => {
  const [isLoading, setLoading] = React.useState(true);
  const [isSaving, setSaving] = React.useState(true);
  const [isShow, setShowModal] = React.useState(false);
  const [name, setName] = React.useState('');
  const [address, setAddress] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [choice, setChoice] = React.useState('');
  const [animal_id, setAnimal_id] = React.useState('');

  


  const buildFormData = () =>{
    const formData = new FormData();
    if(name!="" && name!=undefined && name!="null"){
      
      formData.append("name", name)
    }
    if(address !="" && address!=undefined && address!="null"){

      formData.append("address", address)
    }
    if(phone !="" && phone!=undefined && phone!="null"){
    formData.append("phone", phone)}

    if(idSuitor){
      formData.append('_method', 'PUT')
    }

    if(email !="" && email!=undefined && email!="null"){
      formData.append("email", email)}

    if(choice !="" && choice!=undefined && choice!="null"){

        formData.append("choice", choice);
    }
    if(animal_id!=undefined && animal_id != undefined && animal_id != "null"){
      formData.append("animal_id", animal_id);
    }
    return formData
  }

  const formData = buildFormData();

  const onSave = () => {
    Swal.fire({
      title: 'Certeza que deseja salvar?',
      text: "Você não conseguirá reverter isso!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Salvar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: "#198754",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitData();
      } else if (
          result.dismiss === Swal.DismissReason.cancel
      ) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Operação cancelada!',
          showConfirmButton: false,
          timer: 1500
        })
      }
    })
  }

  const submitData = () => {
    setSaving(true);
    if (idSuitor) {
      BaseApi.post(`/pretendente/${idSuitor}`, formData).then(res => {
        setSaving(false);
        setShowModal(false);
        toast.success('Informação de pretendente a adoção criada com sucesso!');
        onUpdate && onUpdate(res.data);
      }).then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Dados atualizados com sucesso!',
          showConfirmButton: false,
          timer: 1500
        })
      }).catch(err => {
        console.log(err);
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: `${err?.response?.data?.message}`,
          showConfirmButton: false,
          timer: 1500
        })
        setSaving(false);
      })
    }
    else {
      BaseApi.post('/pretendente', formData).then(res => {
        setSaving(false);
        setShowModal(false);
        toast.success('Informação do pretendente a adoção atualizada com sucesso');
        onCreate && onCreate(res.data);
      }).then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Dados criado com sucesso!',
          showConfirmButton: false,
          timer: 1500
        })
      }).catch(err => {
        console.log(err);
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: `${err?.response?.data?.message}`,
          showConfirmButton: false,
          timer: 1500
        })
        setSaving(false);
      })
    }
  }

  const handleClose = () => {
    setShowModal(false);
  }


  const requestData = () => {
    setLoading(true);
    BaseApi.get(`/pretendente${idSuitor ? `/${idSuitor}` : ''}`).then(res => {
      let data = res.data;
      console.log(data.choice);
      setName(data.name);
      setAddress(data.address);
      setPhone(data.phone);
      setEmail(data.email);
      setChoice(data.choice);
      setAnimal_id(data.animal_id);
      setLoading(false);
      setSaving(false);
    }).catch(err => {
      console.log(err);
      Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || 'Ocorreu um erro ao carregar esta ação ou o pretendente não foi encontrado.', 'error');
      setShowModal(false);
    })
  }

  /*Requisição de dados dos animais nao adoados*/
  let [searchParams, setSearchParams] = useSearchParams();

    let controller = new AbortController();

    const INITIAL_FILTERS = {
        search: searchParams.get("search") || "",
    };

    const INITIAL_QUERY = {
        sort: "id",
        order: "desc",
        per_page: 10,
        page: searchParams.get("page") || 1,
    };

    const [isFiltering, setFiltering] = React.useState(true);
    const [isPaginating, setPaginating] = React.useState(true);

    const [query, setQuery] = React.useState({
        ...INITIAL_QUERY,
        ...INITIAL_FILTERS,
    });
    const [filters, setFilters] = React.useState({ ...INITIAL_FILTERS });
    const [animalsData, setAnimalsData] = React.useState({ ...INITIAL_DATA });


  const requestanimalsData = (args = {}) => {
    setLoading(true);
    let q = { ...query, ...args };
    BaseApi.get("/animais_naoadotados", {
    signal: controller.signal,
    params: {
        ...q,
        search: q.search !== "" ? q.search : undefined,
    },
    })
    .then((response) => {
        setAnimalsData(response.data);
        setLoading(false);
        setPaginating(false);
        setFiltering(false);
    })
    .catch((err) => {
        if (err) {
        console.log(err);
        toast.error("Erro ao carregar dados da tabela");
        setAnimalsData({ ...INITIAL_DATA });
        setLoading(false);
        setPaginating(false);
        setFiltering(false);
        }
    });
}; /*Fim da requisição */


  useEffect(() => {
    if(isShow) {
      requestData();
      requestanimalsData();
    } else {
      setName('');
      setAddress('');
      setPhone('');
      setEmail('');
      setChoice('');
      setAnimal_id('');
      setLoading(true);
      setSaving(true);
    }
  }, [isShow])

  return (
    <>
      {children &&
        React.cloneElement(children, { onClick: (e) => setShowModal(true) })}
      {!children && (
        <Tooltip text={idSuitor ? "Editar pretendente a adoação" : "Criar pretendente a adoação"}>
          <button
            className={`btn btn-${idSuitor ? "warning" : ""} text-white fa-bold`}
            onClick={(e) => setShowModal(true)}
          >
            <i className={`bi bi-${idSuitor ? "person-gear" : "plus"}`}></i>
          </button>
        </Tooltip>
      )}
      <Modal
        centered
        scrollable
        onHide={handleClose}
        show={isShow}
        animation={true}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>{idSuitor ? "Editar" : "Criar"} Pretendente</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-center">
            {isLoading && (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}
          </div>
          {!isLoading && (
            <>
              <div className="row">
                <div className="form-group mb-3">
                  <label className={style.required} htmlFor="name">Nome </label> 
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="Insira o Nome"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    
                  />
                </div>

                <div className="form-group mb-3">
                <label className={style.required} htmlFor="address">Endereço </label> 
                  <input
                    type="text"
                    className="form-control"
                    id="address"
                    placeholder="Insira o Endereço"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    
                  />
                </div>

                <div className="form-group mb-3">
                <label className={style.required} htmlFor="phone">Telefone </label> 
                  <input
                    type="phone"
                    className="form-control"
                    id="phone"
                    placeholder="Insira o Telefone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    
                  />
                </div>

                <div className="form-group mb-3">
                <label className={style.required} htmlFor="email">Email </label> 
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder="Insira o email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    
                  />
                </div>

                
                <div className="form-group mb-3">
                  <label className={style.required} htmlFor="animal_id">Animal </label> 
                  <select value={animal_id} name="animal_id" id="animal_id" onChange={(e) => setAnimal_id(e.target.value)} className="form-select">
                      <option value="" disabled='disabled' selected>Qual o animal escolhido</option>
                      {animalsData.data.map((item)=>
                      (
                        <option value={item.id}>{item.name}</option>
                      ))}
                  </select>
                </div>
                 

                <div className="form-group mb-3">
                  <label className={style.required} htmlFor="choice">Adotar ou lar temporário? </label> 
                  <select value={choice} name="choice" id="choice" onChange={(e) => setChoice(e.target.value)} className="form-select">
                      <option value="" disabled='disabled' selected>Adotar ou lar temporário?</option>
                      <option value={'adopt'}>Adotar</option>
                      <option value={'home'}>Lar temporário</option>
                  </select>
                </div>

              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center w-100">
            <div className="d-block me-auto"></div>
            <div className="d-block ms-auto">
              <button
                className="btn btn-danger text-white me-2"
                onClick={handleClose}
              >
                Close
              </button>
              <Button
                loading={isSaving}
                onClick={onSave}
                className="btn btn-success text-white"
              >
                {idSuitor ? "Editar" : "Criar"}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalSuitor;